export enum FiltersType {
  civicService = 'type:service-civique',
  volunteer = 'type:je-veux-aider',
}
